(function () {
  // Quick-add re-injection: never stack listeners, but re-arm so newly rendered cards get impressions.
  if (window.__nsAddonTelemetry) { try { window.__nsAddonTelemetry.arm(); } catch (e) {} return; }
  function publish(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* never break the storefront */ }
  }
  function base(cb) {
    var d = cb.dataset;
    return {
      parentProductId: d.parentProductId || "", parentVariantId: d.parentVariantId || "",
      addonProductId: d.addonProductId || "", addonVariantId: d.variantId || "",
      surface: d.addonSurface || "pdp", position: parseInt(d.addonPosition || "0", 10) || 0,
      disabled: !!cb.disabled, priceCents: parseInt(d.price || "0", 10) || 0,
      pageHandle: (location.pathname.split("/products/")[1] || "").split("/")[0],
    };
  }
  var seen = new WeakSet();
  function arm() {
    var cards = document.querySelectorAll(".js-addon-checkbox");
    if (!cards.length) return;
    if (typeof window.IntersectionObserver !== "function") { cards.forEach(function (c) { if (!seen.has(c)) { seen.add(c); publish("ns_addon_impression", base(c)); } }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && !seen.has(en.target)) { seen.add(en.target); publish("ns_addon_impression", base(en.target)); io.unobserve(en.target); }
      });
    }, { threshold: 0.5 });
    cards.forEach(function (c) { if (!seen.has(c)) io.observe(c); });
  }
  // Capture phase on purpose: the pairs picker's <variant-pair> element calls stopPropagation() on
  // change events, so a bubbling listener on document would never see ticks on the pairs surface.
  document.addEventListener("change", function (e) {
    try {
      if (e.target && e.target.classList && e.target.classList.contains("js-addon-checkbox")) {
        var p = base(e.target); p.checked = !!e.target.checked; publish("ns_addon_toggle", p);
      }
    } catch (err) { /* never break the storefront */ }
  }, true);
  document.addEventListener("ns:addon-added", function (e) {
    try {
      var list = e.detail;
      if (!list || typeof list.length !== "number") return;
      for (var i = 0; i < list.length; i++) {
        try { publish("ns_addon_added", base(list[i])); } catch (err) { /* skip a malformed entry */ }
      }
    } catch (err) { /* never break the storefront */ }
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arm); else arm();
  window.addEventListener("pageshow", function (e) { if (e.persisted) { seen = new WeakSet(); arm(); } });
  window.__nsAddonTelemetry = { publish: publish, base: base, arm: arm };
})();
